import { Select } from '@iqueue/ui-kit'
import HelpersPresenter from '../../api/helpersPresenter'
import { useCallback } from 'react'
import { t } from '../../hooks/useTranslate'

export default function PickSensorStatus({
  name = 'status',
  value,
  ...props
}) {

  const render = useCallback((key) => {
    return {
      id: key,
      title: t(`status.sensor.${ key }`)
    }
  }, [value])

  return <Select
    name={ name }
    entries={ HelpersPresenter.sensorStatuses }
    render={ render }
    value={ value }
    { ...props }
  />
}
